import { createAction } from '@reduxjs/toolkit';

import { moduleName } from '../constants';
import type { AdvancementReportData } from '../types';

const namespace = `${moduleName}` as const;

export const advancementReportResponse = createAction<AdvancementReportData>(
  `${namespace}/ADVANCEMENT_REPORT_RESPONSE`,
);
